import { render, staticRenderFns } from "./securityShiftNew.vue?vue&type=template&id=33e57054&scoped=true&"
import script from "./securityShiftNew.vue?vue&type=script&lang=js&"
export * from "./securityShiftNew.vue?vue&type=script&lang=js&"
import style0 from "./securityShiftNew.vue?vue&type=style&index=0&id=33e57054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e57054",
  null
  
)

export default component.exports